import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik, Form, Field } from 'formik';

import { doForgotPassword } from '../../../redux/ducks/auth';
import pageWrapper from '../../containers/AnonPage';
import AuthBox from '../../containers/AuthBox';
import Button from '../../common/Button';
import FormFeedback from '../../common/form/FormFeedback';
import TextInput from '../../common/form/TextInput';
import FormResult from '../../../FormResult';

import './ForgotPassword.css';

const yup = require('yup');

class ForgotPasswordPage extends React.PureComponent {
  render() {
    return (
      <AuthBox>
        <h2>Forgot Password?</h2>
        <p className="content">
          Enter your email address, and we will send you an email with a link to reset your
          password.
        </p>

        <Formik
          initialValues={{ email: '' }}
          onSubmit={(values, { setSubmitting, setStatus }) => {
            const onSuccess = () => {
              setSubmitting(false);
              setStatus(new FormResult(
                  200,
                  'Your request has been received. If the address matches one on file, you will receive an email with a link to reset your password.'
                ));
            };
            const onFailure = (status) => {
              setSubmitting(false);
              setStatus(new FormResult(status));
            };

            this.props.onSubmit(values.email, onSuccess, onFailure);
          }}
          validationSchema={yup.object().shape({
            email: yup
              .string()
              .trim()
              .email("Doesn't look like a valid email address")
              .required('Email address required'),
          })}
          render={({
            // values,
            // errors,
            // touched,
            status,
            // handleChange,
            // handleBlur,
            handleSubmit,
            isSubmitting,
          }) => (
            <Form>
              <FormFeedback status={status} />

              <Field
                name="email"
                label="Email"
                placeholder="you@example.com"
                type="email"
                autoComplete="username"
                component={TextInput}
              />

              <Button
                type="submit"
                label="Reset my Password"
                color="primary"
                isActive={isSubmitting}
                isDisabled={isSubmitting}
                size="large"
                isFullWidth
                className="forgotPassword-button"
                handler={handleSubmit}
              />
            </Form>
          )}
        />
      </AuthBox>
    );
  }
}

ForgotPasswordPage.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch) {
  return {
    onSubmit: (email, password, onSuccess, onFailure) => {
      dispatch(doForgotPassword(email, password, onSuccess, onFailure));
    },
  };
}

export default pageWrapper(connect(undefined, mapDispatchToProps)(ForgotPasswordPage));



// WEBPACK FOOTER //
// ./src/components/pages/anon/ForgotPassword.jsx